module.exports = __webpack_public_path__ + "static/media/sleepyDragonzFrame8.4c6fdd93.png";